import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import ArrowLeft from 'dibs-icons/exports/legacy/ArrowLeft';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';
import ChevronRight from 'dibs-icons/exports/ChevronRight';

import styles from './HpRecentlyViewedShimmer.scss';

const DesktopShimmer: FC = () => (
    <div className={dibsCss.pyLarge}>
        <div
            className={classnames(
                dibsCss.flex,
                dibsCss.gapLarge,
                dibsCss.wFull,
                dibsCss.itemsCenter
            )}
        >
            <div className={classnames(dibsCss.flexShrink0, dibsCss.w200px)}>
                <div
                    className={classnames(styles.shimmer, styles.shimmerTitle, dibsCss.mbXsmall)}
                />
                <div className={classnames(styles.shimmer, styles.shimmerLink)} />
            </div>
            <div
                className={classnames(
                    dibsCss.flex1,
                    dibsCss.minW0,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.gapMedium
                )}
            >
                <div
                    className={classnames(
                        styles.arrowWrapper,
                        dibsCss.pXsmall,
                        dibsCss.pr0,
                        dibsCss.flexShrink0
                    )}
                >
                    <ArrowLeft className={styles.arrow} />
                </div>
                <div className={classnames(dibsCss.flex1, dibsCss.minW0, dibsCss.overflowHidden)}>
                    <div
                        className={classnames(
                            styles.itemsWrapper,
                            dibsCss.flex,
                            dibsCss.overflowHidden,
                            dibsCss.gapXsmall
                        )}
                    >
                        {[0, 1, 2, 3, 4, 5].map(index => (
                            <div
                                key={index}
                                className={classnames(dibsCss.flex1, dibsCss.minW0, dibsCss.hFull)}
                            >
                                <div
                                    className={classnames(
                                        styles.shimmer,
                                        dibsCss.wFull,
                                        dibsCss.hFull
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className={classnames(
                        styles.arrowWrapper,
                        dibsCss.pXsmall,
                        dibsCss.pl0,
                        dibsCss.flexShrink0
                    )}
                >
                    <ArrowRight className={styles.arrow} />
                </div>
            </div>
        </div>
    </div>
);

const MobileShimmer: FC = () => (
    <div
        className={classnames(
            'primary-viewport-width',
            dibsCss.pyLarge,
            dibsCss.ptMedium,
            dibsCss.pbMedium
        )}
    >
        <div className={classnames(dibsCss.flex, dibsCss.flexCol, dibsCss.gapSmall, dibsCss.wFull)}>
            <div
                className={classnames(
                    dibsCss.plSmall,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.gapXxsmall
                )}
            >
                <div className={classnames(styles.shimmer, styles.shimmerTitleMobile)} />
                <ChevronRight variation="24" />
            </div>
            <div className={classnames(dibsCss.flex1, dibsCss.minW0, dibsCss.overflowHidden)}>
                <div
                    className={classnames(
                        styles.itemsWrapper,
                        dibsCss.flex,
                        dibsCss.overflowHidden,
                        dibsCss.plSmall,
                        dibsCss.gapSmall
                    )}
                >
                    {[0, 1, 2].map(index => (
                        <div
                            key={index}
                            className={classnames(styles.itemMobile, dibsCss.flexShrink0)}
                        >
                            <div
                                className={classnames(styles.shimmer, dibsCss.wFull, dibsCss.hFull)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);

type Props = {
    isMobile: boolean;
};

export const HpRecentlyViewedShimmer: FC<Props> = ({ isMobile }) =>
    isMobile ? <MobileShimmer /> : <DesktopShimmer />;
